const state = {
  messages: []
}

const actions = {
  toggle_mute ({commit}) {
    commit('toogle_mute');
  },
  async start_mail({commit}) {
    setInterval( () => { commit('UPDATE_mail') }, 15000);
  }
}

const mutations = {
  UPDATE_mail (state) {
    var that = this;
    that._vm.$http
    .post('service/gmail/listMessages', {q: 'is:unread'})
    .then(response => {
      state.messages = response.data.messages || [];
    })
    .catch(function (error) {
      console.log('Error - UPDATE_mail store: ', error);
    });
  }
}

const getters = {
  messages: (state) => {
    return state.messages;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
